import { BrowserRouter, Route, Redirect, Switch } from "react-router-dom";
import Home from "./pages/home";
import SearchResults from "./pages/search-results";
import SearchDetails from "./pages/search-details";
import Contact from "./pages/contact";
import Footer from "./constants/Footer";
import ReactGA from "react-ga";
import { hotjar } from "react-hotjar";
import { useDispatch, useSelector } from "react-redux";
import { setScreenSize } from "./redux";
import { setInnerWidth } from "./redux/screenInnerWidth";
import { setIsLargeScreen } from "./redux/isLargeScreen";
import { useEffect } from "react";
import LogoImage from "./constants/LogoPicture";
import AdminPanel from "./pages/admin_panel";
import Testing from "./pages/testing";
import Invitation from "./pages/invitation";
import { setStoqqyLang } from "./constants";
import PortfolioMap from "./pages/portfolio_map";
import EtfSearch from "./pages/etfISIN";
import EtfSearchTable from "./pages/etfISIN/etfSearch";

const stoqqyLang = window.localStorage.getItem("stoqqyLang");

export default function App() {
  const dispatch = useDispatch();
  const handler = (e) => dispatch(setScreenSize(e.matches));
  window.matchMedia("(min-width: 1283px)").addListener(handler);
  ReactGA.initialize("UA-195581724-1");

  useEffect(() => {
    dispatch(setScreenSize(window.matchMedia("(min-width: 1215px)")?.matches));
    dispatch(
      setIsLargeScreen(window.matchMedia("(min-width: 1352px)").matches)
    );
    window.addEventListener("resize", () => {
      const { innerWidth } = window;
      dispatch(setInnerWidth(innerWidth));
      dispatch(
        setIsLargeScreen(window.matchMedia("(min-width: 1352px)").matches)
      );
    });
  });

  const page = window.location.pathname + window.location.search;
  const appInnerWidth = useSelector((state) => state.innerWidth.value);

  useEffect(() => {
    ReactGA.set({ page: page });
    ReactGA.pageview(page);
    hotjar.initialize(2696246, 6);
  });

  useEffect(() => {
    if (!stoqqyLang) {
      console.log("no lang");
      setStoqqyLang("en");
    }
  }, []);

  return (
    <div style={{ display: "flex", justifyContent: "center" }}>
      <div
        style={{ maxWidth: 1440, width: appInnerWidth, overflowX: "hidden" }}
      >
        <LogoImage />
        <BrowserRouter>
          <Switch>
            <Route
              exact
              path="/"
              render={() => {
                return <Redirect to="/home" />;
              }}
            />
            <Route exact path="/home">
              <Home />
            </Route>
            <Route exact path="/search-results/:query/:tab">
              <SearchResults />
            </Route>
            <Route exact path="/search-details/:query/:queryISIN/:tabValue">
              <SearchDetails />
            </Route>
            <Route exact path="/search-map/:query/:tab">
              <PortfolioMap />
            </Route>
            <Route exact path="/contact-us">
              <Contact />
            </Route>
            <Route exact path="/contact-us">
              <Contact />
            </Route>
            <Route exact path="/admin">
              <AdminPanel />
            </Route>
            <Route exact path="/test">
              <Testing />
            </Route>
            <Route exact path="/invitation">
              <Invitation />
            </Route>
            <Route exact path="/etfSearch">
              <EtfSearch />
            </Route>
            <Route exact path="/etfSearch/:query_">
              <EtfSearch />
            </Route>
            <Route exact path="/etfSearch/:query/:symbol">
              <EtfSearchTable />
            </Route>
            <Redirect from="*" to="/" />
          </Switch>
          <Footer />
        </BrowserRouter>
      </div>
    </div>
  );
}
